export default __webpack_public_path__ + "static/media/racing-camel.c76d18b8.png";